import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { ChannelForm } from '../forms/Channel/ChannelForm';

export type ChannelEditorState = {
  form: ChannelForm;
  formLoading: boolean;
  hasErrors: false;
};

export const initialState: ChannelEditorState = {
  form: new ChannelForm(),
  formLoading: false,
  hasErrors: false,
};

const channelEditorSlice = createSlice({
  name: 'ChannelEditor',
  initialState,
  reducers: {
    UpdateForm: (state, action: any) => {
      // console.log('UpdateForm', { state, action });
      state.form = action.payload;
      state.formLoading = false;
    },
    CreateForm: (state, action: any) => {
      state.form = action.payload;
      state.formLoading = false;
    },
  },
  extraReducers: {},
});

export const { UpdateForm, CreateForm } = channelEditorSlice.actions;

// export ouAdminEditorSlice selector to get the slice in any component
export const channelEditorSliceSelector = (state: RootState) => state.channelEditor;
// export The reducer
const channelEditorReducer = channelEditorSlice.reducer;

export default channelEditorReducer;
